import {
  CmsApiCtaHeroBlockData,
  CmsApiCtaHeroBlockLayout,
} from 'modules/cms/api/types/blocks/CmsApiCtaHeroBlock';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsCtaHeroBlock } from './CmsCtaHeroBlock';

export const CmsCtaHeroBlockMapping: CmsBlockMapping<CmsApiCtaHeroBlockData> = {
  invariant: [
    {
      prop: 'text',
      msg: 'Text data required for call to action',
    },
    {
      prop: 'image',
      msg: 'Image data required for call to action',
    },
  ],
  width: (data) => {
    if (data.layout === CmsApiCtaHeroBlockLayout.COMPACT)
      return CmsMappedBlockWidth.NARROW;

    return CmsMappedBlockWidth.FULL;
  },
  Component: CmsCtaHeroBlock,
  AmpComponent: CmsAmpHeroBlock,
};
